/* global System */

export default {
  GlobalBanner: () =>
    System.import(/* webpackChunkName: "GlobalBanner" */ './index'),
}
